import React, { useState, useEffect } from 'react';
import styles from '../App.module.css';
import EventCard from './EventCard';
import { useLocation } from 'react-router-dom';

function AllEvent() {
  const [event_cat, setEvent_cat] = useState([]);
  const [events, setEvents] = useState([]);
  const [eventBanner, setEventBanner] = useState({});
  const location = useLocation();
  const baseurl = process.env.REACT_APP_API_BASE_URL;
  const slug = location.pathname.split("/").filter(Boolean).pop();
  const getEventBanner = async() => {
    try {
      const response = await fetch(`${baseurl}get-pages.php/${slug}`);
      const result = await response.json();
      setEventBanner(result.data.length > 0 && result.data[0]); // Adjust based on your API response       
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {}
  };
  const getEventType = async() => {
    try {
      const response = await fetch(`${baseurl}get-event-type.php`);
      const result = await response.json();
      setEvent_cat(result.data); // Adjust based on your API response       
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {}
  };
  const getAllEvent = async() => {
    try {
      const response = await fetch(`${baseurl}get-all-event.php`);
      const result = await response.json();
      setEvents(result.data); // Adjust based on your API response       
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {}
  };
  useEffect(()=>{
    getEventType()
    getAllEvent()
    getEventBanner()
  },[])
  
  const [activeFilter, setActiveFilter] = useState('all');
  const filteredItems = activeFilter === 'all'
    ? events
    : events.filter(item => item.event_type_id === activeFilter);
  return (
    <>
      <section id="home" className={`${styles.hero} ${styles.about_banner}`} data-aos="fade-up" style={{backgroundImage:`url(${eventBanner.banner_image})`}}>
        <div className="container mx-auto">
          <div className='row'>
            <div className="col-md-12">            
              <h1 className='font-bold leading-12 text-5xl'>Event</h1>
              <p className="text-white text-xl font-semibold mt-2 mb-0 w-50">it is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
            </div>
          </div>
        </div>
      </section>
      <section className="pt-20">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">              
              <h1 className='font-bold text-white leading-12 text-5xl uppercase mb-5'>Event</h1>
            </div>
            <div className="col-md-6">
              <button value="all" onClick={(e) => setActiveFilter(e.target.value)} className={`${activeFilter === 'all' ? 'bg-yellow-400 text-dark' : 'bg-gray-700 text-white'} rounded-pill hover:bg-yellow-400 hover:text-dark font-semibold text-xs py-1.5 px-3 mx-1 mb-2`}>Show all</button>
              {
                event_cat.map((item)=>
                  <button value={item.id} onClick={(e) => setActiveFilter(e.target.value)} className={`${activeFilter === item.id ? 'bg-yellow-400 text-dark' : 'bg-gray-700 text-white'} rounded-pill hover:bg-yellow-400 hover:text-dark font-semibold text-xs py-1.5 px-3 mx-1 mb-2`}>{item.event_type}</button>
                )
              }
              {/* <button value="cat2" onClick={(e) => setActiveFilter(e.target.value)} className={`${activeFilter === 'cat2' ? 'bg-yellow-400 text-dark' : 'bg-gray-700 text-white'} rounded-pill hover:bg-yellow-400 hover:text-dark font-semibold text-xs p-2 px-4 mx-1`}>Category 2</button>
              <button value="cat3" onClick={(e) => setActiveFilter(e.target.value)} className={`${activeFilter === 'cat3' ? 'bg-yellow-400 text-dark' : 'bg-gray-700 text-white'} rounded-pill hover:bg-yellow-400 hover:text-dark font-semibold text-xs p-2 px-4 mx-1`}>Category 3</button> */}
            </div>
            <div className="col-md-6">
              <p className="mb-0 text-white w-4/5">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.</p>
            </div>
          </div>
        </div>
      </section>
      <section className="py-10">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className={`grid ${filteredItems.length ? "grid-cols-2": ""} gap-5`}>                
                {filteredItems.length ? filteredItems.map((item,index) => (                  
                    <EventCard url={item.slug} img={item.image} name={item.title} title={item.event_type} button={index < 1} description={item.sub_title} />
                )) : <p className='mb-0 text-xl text-white m-auto d-inline'>No Event Found!</p>}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default AllEvent